import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import LoggedUserContext from '../../contextProviders/LoggedUserContext';
import Title from '../../commonComponents/Title';
import ContentContainer from '../../commonComponents/pageLayout/ContentContainer';
import SubHeader from '../../commonComponents/pageLayout/SubHeader';
import translate from '../../commonComponents/translate';
import CountryProp from '../../commonComponents/forms/Address/CountryProp';
import LeadForm from './leadDetails/LeadForm';
import { LEAD_CONDITION } from '../../services/utilityFunctions';

function LeadCreate({ t, countries, gameId }) {
  const { loggedUser } = useContext(LoggedUserContext);
  const initialLead = {
    game: gameId,
    condition: LEAD_CONDITION.LEADS,
    user: loggedUser,
  };

  return (
    <Title title={t('leadDetails_head_createTitle')}>
      <ContentContainer>
        <SubHeader
          title={t('leadDetails_createTitle')}
          breadcrumbs={[
            { link: '/challenges', text: t('header_performance_challenges') },
            {
              link: `/challenges/${gameId}`,
              text: t('header_performance_challengeDetails'),
            },
            {
              link: `/challenges/${gameId}/leads`,
              text: t('header_performance_challengeDetails_leads'),
            },
            { link: '', text: t('leadDetails_createTitle') },
          ]}
        />
        <div className="m-content">
          <div className="row full-page-container-with-subheader">
            <div className="col-lg-12">
              <div className="m-portlet m-portlet--mobile">
                <div className="m-portlet__body">
                  <LeadForm
                    isEdit={false}
                    countries={countries}
                    lead={initialLead}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </ContentContainer>
    </Title>
  );
}

LeadCreate.propTypes = {
  t: PropTypes.func.isRequired,
  countries: PropTypes.arrayOf(PropTypes.shape(CountryProp.propType))
    .isRequired,
  gameId: PropTypes.string,
};

LeadCreate.defaultProps = {
  gameId: null,
};

export default translate(LeadCreate);
